import { FileCheck2 } from 'lucide-react';
import {
  ResumeCard,
  ResumeCardHeader,
} from '@/components/commercial/proposals/shared/summary-components';

/**
 * Rendered when the proposal has no applicable contract types (e.g. cart with
 * only ACCESSORY_SALE items). The step is already satisfied (allSigned with an
 * empty list) — inform the user instead of showing a permanently disabled
 * send button.
 */
export function ContractEmptyState() {
  return (
    <ResumeCard>
      <ResumeCardHeader
        title="Assinatura eletrônica do contrato"
        icon={<FileCheck2 className="h-4 w-4 text-gray-400" />}
      />
      <div className="space-y-4 px-5 py-5">
        <div className="flex items-start gap-3">
          <div className="flex h-9 w-9 flex-none items-center justify-center rounded-full bg-gray-100">
            <FileCheck2 className="h-5 w-5 text-gray-600" aria-hidden="true" />
          </div>
          <div className="min-w-0 space-y-1">
            <p className="text-sm font-semibold text-gray-900">
              Esta proposta não possui contratos que exigem assinatura.
            </p>
            <p className="text-xs text-gray-500">
              Os itens desta proposta não exigem assinatura eletrônica de contrato. Você pode
              prosseguir para as próximas etapas do aceite.
            </p>
          </div>
        </div>
      </div>
    </ResumeCard>
  );
}
